export default "__VITE_ASSET__a6Zb4X7a__"